import PolicyPage from '../components/PolicyPage';

const TermsAndConditionsPage = () => {
  return (
    <PolicyPage 
      title="Terms and Conditions"
      metaTitle="Terms and Conditions - Event Participation Guidelines"
      metaDescription="Read the official terms and conditions for Golden Tree Events Dubai. Covers event registration, participation rules, intellectual property, liability, and attendee obligations."
      sourceUrl="https://gtedubai.com/app/terms-and-conditions?awd=gte"
    />
  );
};

export default TermsAndConditionsPage;
